(function () {
  var shown = false;

  function showDynPay() {
    if (shown) return;
    shown = true;

    document.querySelectorAll("[data-dynpay].dynpay--hidden").forEach(function (el) {
      el.classList.remove("dynpay--hidden");
    });
  }

  function init() {
    if (!document.querySelector("[data-dynpay]")) return;

    window.addEventListener("load", function () {
      setTimeout(showDynPay, 8000);
    });

    ["pointerdown", "touchstart", "keydown"].forEach(function (evt) {
      window.addEventListener(evt, showDynPay, { once: true, passive: true });
    });

    // Desktop-only "intent"
    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      window.addEventListener("mousemove", showDynPay, { once: true, passive: true });
    }
  }

  init();
})();